import { useContext } from "react";

import HttpContext from "../contexts/HTTP/HttpContext";

function useServerUpload() {
  const { post } = useContext(HttpContext);

  const handleServerImageUpload = async (images, model) => {
    const formData = new FormData();
    formData.append("model", model._id);
    images.forEach((image) => {
      formData.append("images", image);
    });

    const res = await post("/upload", formData, "multipart/form-data");

    return res;
  };

  const handleServerUrlUpload = async (url, model) => {
    const formData = new FormData();
    formData.append("model", model._id);
    formData.append("url", url);

    const res = await post("/process", formData, "multipart/form-data");

    return res;
  };

  return { handleServerImageUpload, handleServerUrlUpload };
}

export default useServerUpload;
